const health = {
  healthy: "Healthy",
  atRisk: "At Risk",
  critical: "Critical",
} as const;
export default health;
